import { cloneElement, type ReactElement } from 'react'
import { Tooltip } from '@mantine/core'
import { LOCKED_FIELD_MESSAGE, useTranslation } from '@front/model'

type Props = {
  locked: boolean
  children: ReactElement<{ disabled?: boolean }>
}

export const LockedFieldTooltip = ({ locked, children }: Props): ReactElement => {
  const { t } = useTranslation()
  if (!locked) return children

  return (
    <Tooltip label={t(LOCKED_FIELD_MESSAGE)}>
      <div>{cloneElement(children, { disabled: true })}</div>
    </Tooltip>
  )
}
